import getAdditionalContext from './getAdditionalContext'
import * as Sentry from '@sentry/nextjs'
import { noop } from '@betterplace/utils'

function report(error: unknown, context?: Record<string, unknown>) {
  void getAdditionalContext()
    .then((additionalContext) => {
      // eslint-disable-next-line import/namespace
      Sentry.captureException(error, { ...additionalContext, extra: context })
    })
    .catch(noop)
}
export default report
